/*
 * Carrossel horizontal genérico baseado em scroll nativo.
 *
 * O scroll nativo já dá swipe no mobile de graça; o custom element só adiciona
 * as setas de desktop e mantém o estado de "chegou no fim" para escondê-las.
 *
 * Uso:
 *   <scroll-carousel>
 *     <button data-scroll-prev>…</button>
 *     <div data-scroll-viewport>…itens…</div>
 *     <button data-scroll-next>…</button>
 *   </scroll-carousel>
 */
class ScrollCarousel extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-scroll-viewport]');
    this.prevButton = this.querySelector('[data-scroll-prev]');
    this.nextButton = this.querySelector('[data-scroll-next]');
    if (!this.viewport) return;

    this.onScroll = this.updateButtons.bind(this);
    this.viewport.addEventListener('scroll', this.onScroll, { passive: true });

    this.prevButton?.addEventListener('click', () => this.scrollByPage(-1));
    this.nextButton?.addEventListener('click', () => this.scrollByPage(1));

    this.resizeObserver = new ResizeObserver(() => this.updateButtons());
    this.resizeObserver.observe(this.viewport);

    this.updateButtons();
  }

  disconnectedCallback() {
    this.viewport?.removeEventListener('scroll', this.onScroll);
    this.resizeObserver?.disconnect();
  }

  scrollByPage(direction) {
    // Avança ~85% da viewport para manter um item de referência visível.
    const amount = Math.max(1, Math.round(this.viewport.clientWidth * 0.85));
    this.viewport.scrollBy({ left: amount * direction, behavior: 'smooth' });
  }

  updateButtons() {
    const { scrollLeft, scrollWidth, clientWidth } = this.viewport;
    // 2px de folga: navegadores arredondam scrollLeft e o fim nunca bate exato.
    const atStart = scrollLeft <= 2;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;
    const overflows = scrollWidth > clientWidth + 2;

    this.classList.toggle('scroll-carousel--overflowing', overflows);

    if (this.prevButton) {
      this.prevButton.disabled = atStart;
      this.prevButton.hidden = !overflows;
    }
    if (this.nextButton) {
      this.nextButton.disabled = atEnd;
      this.nextButton.hidden = !overflows;
    }
  }
}

if (!customElements.get('scroll-carousel')) {
  customElements.define('scroll-carousel', ScrollCarousel);
}
